/**
 * @generated SignedSource<<a04cb94d7ba2241e6549683c4b561c20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubInvoiceModelStatusChoices = "CANCELLED" | "DRAFT" | "OVERPAID" | "PAID" | "PENDING" | "REFUND" | "SENT" | "%future added value";
export type RemoveLineItemInput = {
  clientMutationId?: string | null | undefined;
  lineItemId: string;
};
export type RemoveLineItemMutation$variables = {
  connections: ReadonlyArray<string>;
  input: RemoveLineItemInput;
};
export type RemoveLineItemMutation$data = {
  readonly removeLineItem: {
    readonly deletedLineItemId: string | null | undefined;
    readonly errors: any | null | undefined;
    readonly invoice: {
      readonly id: string;
      readonly lastModified: string;
      readonly status: PianofunclubInvoiceModelStatusChoices;
      readonly totalAmount: number | null | undefined;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type RemoveLineItemMutation = {
  response: RemoveLineItemMutation$data;
  variables: RemoveLineItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedLineItemId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "InvoiceNode",
  "kind": "LinkedField",
  "name": "invoice",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastModified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveLineItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveLineItemPayload",
        "kind": "LinkedField",
        "name": "removeLineItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveLineItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveLineItemPayload",
        "kind": "LinkedField",
        "name": "removeLineItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedLineItemId",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f97fcc597a3e6ae2a828ce40357a8dc2",
    "id": null,
    "metadata": {},
    "name": "RemoveLineItemMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveLineItemMutation(\n  $input: RemoveLineItemInput!\n) {\n  removeLineItem(input: $input) {\n    success\n    errors\n    deletedLineItemId\n    invoice {\n      id\n      lastModified\n      totalAmount\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e810cea90f2516c0626288a489c11d4";

export default node;
